import { selectGeneralStation } from '../redux/selectors';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

function useDerateCalc() {
    const generalSpecsDetails = useSelector(selectGeneralStation);
    const jobId = useSelector((state) => state.jobId.jobId);
    const activeTab = useSelector((state) => state.activeMechanicalTab.selectedZone);
    const [derate, setDerate] = useState('N/A');

    useEffect(() => {
        const calculateDerate = async () => {
            try {
                const project = generalSpecsDetails.find((detail) => detail.Zone === activeTab);

                if (project) {
                    const siteElevation = project.SiteElevation;
                    const derateValue = getDerate(siteElevation);
                    setDerate(derateValue);
                } else {
                    setDerate('N/A');
                }
            } catch (error) {
                console.error('Error fetching general specs:', error);
                setDerate('N/A');
            }
        };

        calculateDerate();
    }, [generalSpecsDetails, jobId, activeTab]);

    return derate;
}

function getDerate(elevation) {
    if (elevation === undefined || elevation === null || isNaN(elevation)) {
        return 'N/A';
    } else if (elevation < 3300) {
        return 'N/A';
    } else if (elevation < 5000) {
        return 0.97;
    } else if (elevation < 6600) {
        return 0.94;
    } else if (elevation < 8300) {
        return 0.91;
    } else if (elevation < 9900) {
        return 0.88;
    } else {
        return 0.85;
    }
}

export default useDerateCalc;